import React from 'react';
import PropTypes from 'prop-types';
import {
  StyledTradeEmpty,
  StyledIcon,
  StyledHeader,
  StyledContent
} from './Styles';

import { CardType } from '../../_shared/types/trade';

const propTypes = {
  variant: PropTypes.oneOf([CardType.PLAIN]),
  header: PropTypes.element,
  content: PropTypes.element
};

const defaultProps = {
  variant: undefined,
  header: undefined,
  content: undefined
};

const TradeCardEmpty = ({ variant, header, content }) => {
  const showIcon = () => variant !== CardType.PLAIN;

  return (
    <StyledTradeEmpty testId="tradeCardEmpty">
      {showIcon() && <StyledIcon />}
      <div>
        <StyledHeader testId="tradeCardEmpty-header" variant={variant}>
          {header}
        </StyledHeader>
        <StyledContent testId="tradeCardEmpty-content" variant={variant}>
          {content}
        </StyledContent>
      </div>
    </StyledTradeEmpty>
  );
};

TradeCardEmpty.propTypes = propTypes;
TradeCardEmpty.defaultProps = defaultProps;

export default TradeCardEmpty;
